export const GET_LOGO = "getLogo";
export const GET_UNREAD_NOTIFICATIONS = "getUnreadNotifications";
export const CURRENT_MONTH = "currentMonth";
export const CALENDAR_ENABLED = "calendarEnabled";
export const WEEKLY_CALENDAR_ENABLED = "weeklyCalendarEnabled";
export const NEWSLETTER_ENABLED = "newsletterEnabled";
export const AVAILABLE_LOCATIONS = "availableLocations";
export const NEWSLETTER_AVAILABLE = "newsletterAvailable";
export const FLAT_SIZES = "flatSizes";
export const POSTER_SIZES = "posterSizes";
export const WEEKLY_CALENDAR_AVAILABLE_SIZES = "weeklyCalendarAvailableSizes";
export const WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES =
    "weeklyCalendarAvailableFlatSizes";
export const WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES =
    "weeklyCalendarAvailablePosterSizes";
export const MONTHLY_CALENDAR_LOCATIONS = "monthlyCalendarLocations";
export const WEEKLY_CALENDAR_LOCATIONS = "weeklyCalendarLocations";
export const NEWSLETTER_REQUIRES_QUANTITY = "newsletterRequiresQuantity";
export const NEWSLETTER_REQUIRES_COLOR_TYPE = "newsletterRequiresColorType";
export const NEWSLETTER_QUANTITY_OPTIONS = "newsletterQuantityOptions";
export const REQUIRES_SHIPPING_RATE = "requiresShippingRate";
export const CALENDAR_DIGITAL_FILES = "calendarDigitalFiles";
export const NEWSLETTER_DIGITAL_FILES = "newsletterDigitalFiles";
export const BRAND_COLOR = "brandColor";
export const DEFAULT_BRAND_COLOR = "defaultBrandColor";
export const CALENDAR_QUANTITY_OPTIONS = "calendarQuantityOptions";
